const Footer = () => {
  return (
    <div style={{height: '32px'}}></div>
  );
};
export default Footer;
